<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <b-button
        :type="{
          'is-white': t.details.status === 'open',
          'is-success': t.details.status === 'success',
          'is-smart-orange-7': t.details.status === 'refused',
          'is-light': t.details.status === 'cancelled',
          'is-warning': t.details.status === 'error',
          'is-dark': t.details.status === 'refunded',
          'is-danger': t.details.status === 'chargeback',
          'is-sea': t.details.status === 'pending',
          'is-light-green':
            t.details.status === 'billingPending' ||
            t.details.status === 'chargebackPaid'
        }"
        :disabled="t.details.status === 'cancelled'"
        slot="trigger"
      >
        {{
          t.details.status === "success"
            ? $t("transactions.statusSuccess")
            : t.details.status === "refused"
            ? $t("transactions.statusRefused")
            : t.details.status === "error"
            ? $t("transactions.statusError")
            : t.details.status === "cancelled"
            ? $t("transactions.statusCancelled")
            : t.details.status === "open"
            ? $t("transactions.statusOpen")
            : t.details.status === "pending"
            ? $t("transactions.statusPending")
            : t.details.status === "refundedRequested"
            ? $t("transactions.statusRefundRequested")
            : t.details.status === "refunded"
            ? $t("transactions.statusRefunded")
            : t.details.status === "refundRefused"
            ? $t("transactions.statusRefundRefused")
            : t.details.status === "refundFailed"
            ? $t("transactions.statusRefundFailed")
            : t.details.status === "refundReversed"
            ? $t("transactions.statusRefundReversed")
            : t.details.status === "chargeback"
            ? $t("transactions.statusChargeback")
            : t.details.status === "chargebackPaid"
            ? $t("transactions.statusChargebackPaid")
            : "-"
        }}
      </b-button>
    </template>

    <div v-if="t.details.status !== 'cancelled'">
      <b-dropdown-item aria-role="listitem">
        <p>{{ paymentMethods }}</p>
      </b-dropdown-item>

      <b-dropdown-item
        aria-role="listitem"
        v-if="['refused', 'error'].includes(t.details.status)"
      >
        <b>{{ $t("transactions.response") }}: </b>
        {{ t.tefTerminal.response.message }}
      </b-dropdown-item>
    </div>
    <dropdown-item-combo :t="t" />
  </b-dropdown>
</template>

<script>
import { mask } from "../../../mixins/mask";
import dropdownItemCombo from "./DropdownItemCombo.vue";

export default {
  components: {
    dropdownItemCombo
  },

  mixins: [mask],

  props: ["t"],

  computed: {
    paymentMethods() {
      let p = [];

      if (this.t.details.fundingSource === "credit") {
        p.push(this.$t("transactions.credit"));
      }

      if (this.t.details.fundingSource === "debit") {
        p.push(this.$t("transactions.debit"));
      }

      if (this.t.details.fundingSource === "pix") {
        p.push(this.$t("transactions.pix"));
      }

      return p.join(" + ");
    }
  }
};
</script>

<style scoped>
.separator {
  height: 1px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.bill-separator {
  height: 1px;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}
.is-white,
.is-white:hover {
  border: 1px solid #dedede;
}
</style>
